import React from 'react'

import i18n from 'i18next'

import Icon from '@components/icon/Icon'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

import { HandleConfirmPrompt } from './slide-panel-types'

type SlideActionsButtonProps = {
  slideId: number
  handleConfirmPrompt: HandleConfirmPrompt
  selectedSlideIds: number[]
  hasDescription: boolean
}

const SlideActionsButton = ({
  slideId,
  handleConfirmPrompt,
  selectedSlideIds,
  hasDescription
}: SlideActionsButtonProps) => {
  const isMultipleDelete = selectedSlideIds.length > 1 && selectedSlideIds.includes(slideId)

  return (
    <span className="slide-actions-trigger">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="slide-actions-button"
            aria-label={i18n.t('editor.left-panel.slides.actions')}
            aria-haspopup="menu"
          >
            <Icon name="ellipsis-v" size={0.9} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => handleConfirmPrompt('duplicate', slideId)}>
            <Icon name="copy" size={0.8} />
            {i18n.t('editor.left-panel.slides.duplicate')}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => handleConfirmPrompt('name', slideId)}>
            <Icon name="pen" size={0.8} />
            {hasDescription
              ? i18n.t('editor.left-panel.slides.edit-description')
              : i18n.t('editor.left-panel.slides.name')}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            variant="destructive"
            onSelect={() => handleConfirmPrompt('delete', slideId)}
          >
            <Icon name="trash" size={0.8} />
            {isMultipleDelete
              ? i18n.t('editor.left-panel.slides.delete-multiple')
              : i18n.t('editor.left-panel.slides.delete')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </span>
  )
}

export default SlideActionsButton
